import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { Checkbox, FormControlLabel, CircularProgress } from '@material-ui/core';
import Input from '../../../../components/input/Input';
import ModalSlider from '../../../../components/modal-slider/modal-slider';
import { useLazyQuery, useMutation } from 'react-apollo';
import { FIND_DADOS_SECRETARIA } from '../../../../graphql/queryes';
import { UPDATE_DADOS_SECRETARIA } from '../../../../graphql/mutations';

const ModalSecretariaVirtual = ({ open, onClose, dadosDaVenda, setNotification }) => {
  const [config, setConfig] = useState({
    utilizaPlugzapi: false,
    utilizaWaba: false,
    token: '',
    url: '',
  });

  const [fetchDadosSecretaria, { data, loading }] = useLazyQuery(FIND_DADOS_SECRETARIA, {
    fetchPolicy: 'no-cache',
  });

  const [updateDadosSecretaria, { loading: loadingSave }] = useMutation(UPDATE_DADOS_SECRETARIA);

  useEffect(() => {
    if (open && dadosDaVenda?.unidade?.id) {
      fetchDadosSecretaria({
        variables: { idUnidade: dadosDaVenda.unidade.id },
      });
    }
  }, [open, dadosDaVenda, fetchDadosSecretaria]);

  useEffect(() => {
    if (data?.findDadosSecretaria) {
      setConfig({
        utilizaPlugzapi: data.findDadosSecretaria.utilizaPlugzapi || false,
        utilizaWaba: data.findDadosSecretaria.utilizaWaba || false,
        token: data.findDadosSecretaria.token || 'F19ac4c612d7b42308df62617042fba6fS',
        url: data.findDadosSecretaria.url || '',
      });
    }
  }, [data]);

  const handleSave = async () => {
    try {
      await updateDadosSecretaria({
        variables: {
          idUnidade: dadosDaVenda.unidade.id,
          utilizaPlugzapi: config.utilizaPlugzapi,
          utilizaWaba: config.utilizaWaba,
          urlPlugzapi: config.url,
          tokenPlugzapi: config.token,
        },
      });
      setNotification({
        variant: 'success',
        isOpen: true,
        message: 'Dados atualizados com sucesso!',
      });
      onClose();
    } catch (error) {
      setNotification({
        variant: 'error',
        isOpen: true,
        message: 'Erro ao atualizar dados!',
      });
    }
  };

  return (
    <ModalSlider
      isOpen={open}
      onClose={onClose}
      title="Secretaria virtual"
    >
      <Container>
        {loading ? (
          <LoadingContainer>
            <CircularProgress />
          </LoadingContainer>
        ) : (
          <>
            <Box>
              <FormControlLabel
                control={
                  <Checkbox
                    color='primary'
                    checked={config.utilizaPlugzapi}
                    onChange={(e) => setConfig({
                      ...config,
                      utilizaPlugzapi: e.target.checked,
                      utilizaWaba: e.target.checked ? false : config.utilizaWaba
                    })}
                  />
                }
                label="Utiliza plugzapi"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    color='primary'
                    checked={config.utilizaWaba}
                    onChange={(e) => setConfig({
                      ...config,
                      utilizaWaba: e.target.checked,
                      utilizaPlugzapi: e.target.checked ? false : config.utilizaPlugzapi
                    })}
                  />
                }
                label="API Oficial WhatsApp (WABA)"
              />
              {
                config.utilizaPlugzapi && (
                  <>
                    <InputContainer>
                      <label>URL</label>
                      <Input
                        value={config.url}
                        onChange={(e) => setConfig({ ...config, url: e.target.value })}
                        iconLeft={null}
                      />
                    </InputContainer>
                    <InputContainer>
                      <label>Token</label>
                      <Input
                        value={config.token}
                        onChange={(e) => setConfig({ ...config, token: e.target.value })}
                        iconLeft={null}
                      />
                    </InputContainer>
                  </>
                )
              }
            </Box>
            <ButtonContainer>
              <ButtonSave
                onClick={handleSave}
                disabled={loadingSave || (config.utilizaPlugzapi && (!config.url || !config.token))}
              >
                {loadingSave ? <CircularProgress size={20} color="inherit" /> : 'Salvar'}
              </ButtonSave>
            </ButtonContainer>
          </>
        )}
      </Container>
    </ModalSlider>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  height: 100%;
`;

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
`;

const Box = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 16px;

  label {
    font-weight: 600;
    font-size: 14px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: auto;
`;

const ButtonSave = styled.button`
  background-color: #26ACA9;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 10px 24px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export default ModalSecretariaVirtual;
